import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../supabase';

function Urunler() {
  const navigate = useNavigate();
  const { kategoriParam } = useParams(); 

  const kategoriSozlugu = {
    'guvenlik-fileleri': 'Güvenlik Fileleri',
    'is-guvenligi': 'İş Güvenliği Ekipmanları',
    'zayif-akim': 'Zayıf Akım Sistemleri'
  };

  const guvenliParam = kategoriParam ? kategoriParam.toLowerCase().trim() : '';
  const baslangicKategorisi = (guvenliParam && kategoriSozlugu[guvenliParam]) ? kategoriSozlugu[guvenliParam] : 'Hepsi';
  
  const [activeKategori, setActiveKategori] = useState(baslangicKategorisi);
  const [urunler, setUrunler] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- EFSANEVİ SAYFALAMA (PAGINATION) MOTORU ---
  const [mevcutSayfa, setMevcutSayfa] = useState(1);
  const sayfaBasinaUrun = 6; // Her sayfada tam 6 ürün gösterecek

  const kategoriler = ['Hepsi', 'Güvenlik Fileleri', 'İş Güvenliği Ekipmanları', 'Zayıf Akım Sistemleri'];

  useEffect(() => {
    if (guvenliParam && kategoriSozlugu[guvenliParam]) {
      setActiveKategori(kategoriSozlugu[guvenliParam]);
    } else {
      setActiveKategori('Hepsi');
    }
    // Kategori her değiştiğinde sayfalama sistemini zorla 1. sayfaya sıfırla ki müşteri kaybolmasın!
    setMevcutSayfa(1); 
  }, [guvenliParam]);

  useEffect(() => {
    let isMounted = true; 

    const urunleriGetir = async () => {
      setLoading(true);
      try {
        let query = supabase.from('urunler').select('*').order('olusturulma_tarihi', { ascending: false });
        
        if (activeKategori !== 'Hepsi') {
          query = query.eq('kategori', activeKategori);
        }

        const { data, error } = await query;
        if (error) throw error;
        
        if (isMounted) {
          setUrunler(data);
        }
      } catch (error) {
        console.error("Ürünler çekilirken hata:", error.message);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    urunleriGetir();

    return () => { isMounted = false; };
  }, [activeKategori]);

  const handleKategoriClick = (kat) => {
    if (kat === 'Hepsi') {
      navigate('/urunler');
    } else {
      const urlFormat = Object.keys(kategoriSozlugu).find(key => kategoriSozlugu[key] === kat);
      navigate(`/urunler/${urlFormat}`);
    }
  };

  // --- SİHİRLİ MATEMATİK: Sayfada gösterilecek 6 ürünü kesme ---
  const sonUrunIndex = mevcutSayfa * sayfaBasinaUrun;
  const ilkUrunIndex = sonUrunIndex - sayfaBasinaUrun;
  const gosterilecekUrunler = urunler.slice(ilkUrunIndex, sonUrunIndex);
  
  // Toplam sayfa sayısı hesabı
  const toplamSayfa = Math.ceil(urunler.length / sayfaBasinaUrun);

  // Sayfa değiştirildiğinde en yukarı yumuşakça kaydırma motoru
  const sayfaDegistir = (sayfaNumarasi) => {
    setMevcutSayfa(sayfaNumarasi);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="kameralar-page-square">
      <div className="kameralar-header-square">
        <h1>Ürün Kataloğu</h1>
        <p>Demir Grup kalitesiyle profesyonel ekipmanlar ve sistem çözümleri.</p>
        
        <div className="kategori-filtre-bar">
          {kategoriler.map((kat) => (
            <button 
              key={kat} 
              className={activeKategori === kat ? 'active' : ''} 
              onClick={() => handleKategoriClick(kat)}
            >
              {kat}
            </button>
          ))}
        </div>
      </div>
      
      {loading ? (
        <div className="premium-loader-container">
          <div className="dg-spinner"></div>
          <div className="premium-loader-text">Sistem Yükleniyor...</div>
        </div>
      ) : urunler.length === 0 ? (
        <div style={{textAlign: 'center', color: '#94a3b8', marginTop: '50px'}}>Bu kategoride henüz ürün bulunmuyor.</div>
      ) : (
        <>
          <div className="kamera-grid-square">
            {/* Sadece hesaplanan 6 ürünü basıyoruz! */}
            {gosterilecekUrunler.map((urun) => (
              <div key={urun.id} className="kamera-card-square" onClick={() => navigate(`/urun/${urun.id}`)}>
                <img src={urun.resimler && urun.resimler[0]} alt={urun.baslik} className="square-image" />
                <div className="square-overlay">
                  <div className="overlay-left">
                    <span className="mini-tag">{urun.kategori}</span>
                    <h3>{urun.baslik}</h3>
                  </div>
                  <div className="go-icon">➔</div>
                </div>
              </div>
            ))}
          </div>

          {/* --- LÜKS SAYFALAMA BUTONLARI (Eğer 6'dan fazla ürün varsa görünür) --- */}
          {toplamSayfa > 1 && (
            <div className="pagination-container">
              <button 
                onClick={() => sayfaDegistir(mevcutSayfa - 1)} 
                disabled={mevcutSayfa === 1}
                className="page-btn nav-btn"
              >
                &#10094; Önceki
              </button>
              
              {[...Array(toplamSayfa)].map((_, index) => (
                <button 
                  key={index} 
                  onClick={() => sayfaDegistir(index + 1)} 
                  className={`page-btn ${mevcutSayfa === index + 1 ? 'active' : ''}`}
                >
                  {index + 1}
                </button>
              ))}

              <button 
                onClick={() => sayfaDegistir(mevcutSayfa + 1)} 
                disabled={mevcutSayfa === toplamSayfa}
                className="page-btn nav-btn"
              >
                Sonraki &#10095;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Urunler;